/**
 * Base de la API.
 *
 * Antes cada servicio apuntaba a http://ventasvirtuales.mov.com.ec/ (Movistar) o
 * http://virtualcenter.claro.com.ec/ (Claro). Eso ataba el build a una empresa y,
 * peor, no funciona fuera de la red interna: son nombres de DNS privado.
 *
 * Ahora todo va contra el mismo origen del sitio. El servidor decide a qué CRM
 * corresponde según el tenant, y el token nunca llega al navegador.
 */
const Url = {
    Api: '/ApiPrubeaReact/',
    Crm: '/ApiPrubeaReact/crm/',
};

export default Url;
